import { render, staticRenderFns } from "./SharedWithMe.vue?vue&type=template&id=7c65e12f&scoped=true&"
import script from "./SharedWithMe.vue?vue&type=script&lang=js&"
export * from "./SharedWithMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65e12f",
  null
  
)

export default component.exports